import {
  CUSTOM_DEDUCTIONS,
  CUSTOM_EARNINGS,
  REIMBURSEMENTS,
  STANDARD_EARNINGS,
  STATUTORY_DEDUCTIONS
} from '../state.constants'

export interface Info {
  deductionPlan?: string
  payType?: string
  calculationType?: string
  paymentFrequency?: string
  taxDeductionPreference?: string
  taxable?: boolean
  isInCTC?: boolean
  isInFBP?: boolean
  proRataBasis?: boolean
  EPFContribution?: boolean
  ESIContribution?: boolean
  optional?: boolean
}

export interface SalaryComponent {
  id: string
  belongsTo: string | null
  name: string
  description: string | null
  componentType: string
  info: Info
}

export interface SalaryComponentsState {
  salaryComponents: Record<string, SalaryComponent[]> // Group items by type
  loading: boolean
  error: string | null
}

export const initialState: SalaryComponentsState = {
  salaryComponents: {
    [CUSTOM_EARNINGS]: [],
    [STATUTORY_DEDUCTIONS]: [],
    [STANDARD_EARNINGS]: [],
    [CUSTOM_DEDUCTIONS]: [],
    [REIMBURSEMENTS]: []
  },
  loading: false,
  error: null
}
